<template>
    <div class="user-menu-wrap">
        <!--
        <div v-if="$store.state.user.userToPublic" style="margin-left:15px" class="hide-mobile-991">
            <div class="seg seg-dark">
                <button @click="switchToAdmin()" :class="$store.state.user.isAdmin ? 'on' : ''">Admin</button>
                <button @click="switchToPublic()" :class="$store.state.user.isAdmin ? '' : 'on'">Standard</button>
            </div>
        </div>
        -->
        <div @click="() => { $store.state.showSubMenu = !$store.state.showSubMenu }" class="user-display">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 7.001c0 3.865-3.134 7-7 7s-7-3.135-7-7c0-3.867 3.134-7.001 7-7.001s7 3.134 7 7.001zm-1.598 7.18c-1.506 1.137-3.374 1.82-5.402 1.82-2.03 0-3.899-.685-5.407-1.822-4.072 1.793-6.593 7.376-6.593 9.821h24c0-2.423-2.6-8.006-6.598-9.819z"/></svg>
        </div>
        <div v-if="$store.state.user.firstName || $store.state.user.companyName" class="user-display-name" @click="() => { $store.state.showSubMenu = !$store.state.showSubMenu }">
            <strong>{{ [$store.state.user.firstName, $store.state.user.lastName].filter(Boolean).join(' ') }}</strong>
            <span>{{ $store.state.user.companyName }}</span>
        </div>
        <div :style="$store.state.showSubMenu ? 'opacity: 1; pointer-events: auto;' : ''" class="user-options-wrap">
            <div class="user-options">
                <!-- The header's quick add buttons, when the header is too narrow for them (under 1300px) -->
                <div v-if="$store.state.user.employeeID" class="user-quick-add">
                    <a @click.prevent="quickAdd('task')">Add Task</a>
                    <a @click.prevent="quickAdd('agenda')">Add Agenda Item</a>
                </div>
                <div v-if="$store.state.user.userToPublic" class="mobile-991">
                    <div class="seg seg-dark">
                        <button style="margin:0" @click="switchToAdmin()" :class="$store.state.user.isAdmin ? 'on' : ''">Admin</button>
                        <button style="margin:0" @click="switchToPublic()" :class="$store.state.user.isAdmin ? '' : 'on'">Standard</button>
                    </div>
                </div>
                <!-- For the same people as the nav's Settings > Notifications (settingsNav.ts) -->
                <a v-if="canOpenNotifications" @click.prevent="openNotifications()">Notifications</a>
                <a v-if="!$store.state.user.returnAdminID && !$store.state.user.supportSession" @click.prevent="() => { $store.state.showChangePassword = true; }">Change Password</a>
                <a @click.prevent="logOut()">Log Out</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { settingsLinks } from '@/settingsNav';

export default defineComponent({
    name: 'UserSubMenu',
    props: [  ],
    components: {
        
    },
    data() {
        return {

        }
    },
    computed: {
        canOpenNotifications(): boolean {
            return settingsLinks(this.$store.state.user).some(link => link.to == '/notifications');
        }
    },
    methods: {
        openNotifications() {
            this.$store.state.showSubMenu = false;
            this.$router.push('/notifications');
        },
        // Opens the header's quick add (App.vue) and closes this menu
        quickAdd(kind: string) {
            this.$store.state.showSubMenu = false;
            this.$store.state.quickAdd = kind;
        },
        async logOut() {
            localStorage.removeItem('playbook_jwt');
            await axios.get(`${this.$store.state.apiUrl}/api/logout`)
                .catch(e => {
                    console.log(e);
                })

            window.location.reload();
        },
        async switchToAdmin() {
            axios.get(`${this.$store.state.apiUrl}/api/switchtoadmin`)
                .then(resp => {
                    window.location.href = '/';
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })
        },
        async switchToPublic() {
            axios.get(`${this.$store.state.apiUrl}/api/signinasuser?phone=${encodeURIComponent(this.$store.state.user.userToPublic.Phone)}&ignoreReturnAdminID=t`)
                .then(resp => {
                    window.location.href = '/';
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })
        },
        handleOutsideRowMenuClick(e: MouseEvent) {
            if(this.$store.state.showSubMenu && !(e.target as HTMLElement).closest('.user-menu-wrap')) {
                this.$store.state.showSubMenu = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideRowMenuClick);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideRowMenuClick);
    }
});
</script>